<template>
  <div>
    <b-row>
      <b-col
        md="8"
      >
        <!-- Header: Personal Info -->
        <div class="d-flex text-primary">
          <h4 class="mb-0 ml-50 text-primary">
            Selecciona para descargar tu reporte
          </h4>
        </div>

        <!-- Form: -->
        <validation-observer ref="simpleRules">
          <b-form class="mt-1">
            <b-row>
              <!-- Plan -->
              <b-col
                cols="12"
                md="12"
                lg="6"
              >
                <b-form-group>
                  Plan:
                  <v-select
                    v-model="planFilter"
                    :options="planOptions"
                    :reduce="plan => plan.id"
                    label="nombre"
                    :value="planFilter"
                    placeholder="Selecciona"
                  >
                    <template #no-options>
                      Selecciona un plan de estudios
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <!-- Periodo -->
              <b-col
                cols="12"
                md="12"
                lg="6"
              >
                <b-form-group>
                  Personas que se registraron en el periodo (opcional):
                  <v-select
                    v-model="periodoFilter"
                    :options="periodos"
                    :reduce="period => period.periodo"
                    label="clave"
                    :value="(periodoFilter === null)?'Selecciona un periodo válido':periodoFilter"
                    placeholder="Selecciona"
                  >
                    <template #no-options>
                      Selecciona primero el plan de estudios
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- tag source -->
            <b-row>
              <b-col
                cols="12"
                md="12"
                lg="12"
              >
                <div
                  class="card business-card"
                >
                  <div class="business-items">
                    <div class="card-body">
                      <p class="card-text">
                        Selecciona las columnas que quieres consultar en tu reporte:
                      </p>
                      <div
                        class="business-item"
                      >
                        <div class="d-flex align-items-center justify-content-between">
                          <b-form-checkbox-group
                            id="checkbox-group-2"
                            v-model="selectedCheckboxColumn"
                            name="columnasSeleccionadas"
                            class="demo-inline-spacing"
                          >
                            <b-form-checkbox
                              v-for="column in columnDisponibles"
                              :key="column"
                              :value="column"
                            >
                              {{ column }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>
      <b-col
        md="4"
      >
        <div
          class="card business-card"
        >
          <div class="business-items">
            <div class="card-body">
              <p class="card-text">
                Estados de seguimiento:
              </p>
              <div
                class="business-item"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <b-form-checkbox-group
                    id="checkbox-group-2"
                    v-model="selectedCheckbox"
                    name="estados"
                    class="demo-inline-spacing"
                  >
                    <b-form-checkbox value="ACT">
                      ACT : El aspirante ha concluido su pre-registro
                    </b-form-checkbox>
                    <b-form-checkbox value="ST2">
                      ST2 : El aspirante a concluido su registro, (esta en espera de subir documentos o de ser autorizado por control escolar para generar la orden de pago)
                    </b-form-checkbox>
                    <b-form-checkbox value="ST3">
                      ST3 : <br>3.1 Control Escolar Generó una orden de inscripción.
                      <br>3.2 El alumno debe ir a pagar y subir el comprobante.
                    </b-form-checkbox>
                    <b-form-checkbox value="ST4">
                      ST4 : El aspirante se matriculó como alumno
                    </b-form-checkbox>
                    <b-form-checkbox value="ST5">
                      ST5 : El alumno crea su usuario y contraseña (Proceso de inscripción terminado)
                    </b-form-checkbox>
                    <b-form-checkbox value="CAN">
                      CAN : Pre-registro cancelado
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-button
          :disabled="(planFilter != null)?false:true"
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          @click.prevent="descargaReporte()"
        >
          Descargar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  watch,
}
  from '@vue/composition-api'
import {
  BRow, BCol, BForm, BFormGroup, BButton, BFormCheckbox, BFormCheckboxGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationObserver } from 'vee-validate'
import { periodsFromPlan } from '@/views/public/oferta-academica/useDetalleOferta'
import {
  useReportesCatalogos,
} from '@/views/campus/components/reportes/useReportes'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { timestampToDate } from '@core/utils/filter'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormCheckboxGroup,
    BFormCheckbox,
    vSelect,
    //
    BFormGroup,
    BForm,

    ValidationObserver,
  },
  props: {
    loader: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { loader } = props
    const columnDisponibles = ref(['nombre', 'curp', 'municipio_nacimiento', 'estado_nacimiento', 'lugar_nacimiento', 'estado', 'dependencia', 'email',
      'emailAlt', 'telefono', 'telefono2', 'extension', 'matricula', 'status', 'fecha_preregistro', 'ciclo_ingreso',
      'ultimo_periodo_curso', 'temporalidad', 'tipo_beca', 'porcentaje_beca', 'domicilio', 'calle', 'numero', 'interior', 'cp', 'colonia', 'municipio_domicilio', 'estado_domicilio', 'carrera', 'estado_titulacion', 'cedula', 'institucion_educativa', 'cct',
      'fecha_para_autoridad_educativa', 'fecha_inicio_antecedente', 'fecha_fin_antecedente', 'cargo', 'municipio', 'carta_compromiso', 'carta_motivo', 'medio', 'otro_medio', 'orden_referencia', 'orden_status'])
    const selectedtipo = ref(1)
    const TipoOptions = ref([
      { item: { formato: 'xlsx', value: 1 }, name: 'General de Status Académico (ya no se requiere, borrar al final)' },
      { item: { formato: 'xlsx', value: 2 }, name: 'Reporte Específico de Estatus Académico por Asignatura' },
      { item: { formato: 'pdf', value: 3 }, name: 'Final de calificaciones por asignatura', notEnabled: false },
    ])
    const periodos = ref([])
    const selectedCheckbox = ref([])
    const selectedCheckboxColumn = ref([])
    const periodoFilter = ref(null)
    const toast = useToast()
    const planFilter = ref(null)
    const fechas = ref({})
    const periodoIdSelected = ref(null)
    const informacionReporte = ref([])
    const {
      planOptions, planOptionsPromise, reporteAspirantesPromise, statusOptions,
    } = useReportesCatalogos()
    function loadPeriodos() {
      // this.calendario = null
      periodos.value = []
      if (planFilter.value != null) {
        periodsFromPlan(planFilter.value).then(response => {
          periodos.value = response
        }, error => {
          if (error) {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: 'En este momento no podemos entregar tu información. Intenta más tarde.',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 9000 })
          }
        })
      }
    }
    watch(planFilter, () => {
      periodos.value = []
      periodoFilter.value = null
      loadPeriodos()
    })
    watch(periodoFilter, () => {
      if (periodoFilter.value != null) {
        const index = periodos.value.map(el => el.periodo).indexOf(periodoFilter.value)

        fechas.value.inicio = periodos.value[index].fecha_ini
        fechas.value.fin = periodos.value[index].fecha_fin
        periodoIdSelected.value = periodos.value[index].id
      }
    })

    function loadPlan() {
      // loader.value.filters = true
      planOptionsPromise()
        .then(response => {
          planOptions.value = response
          // loader.value.filters = false
        })
        .catch(error => {
          // loader.value.filters = false
          // errorContent.value.filters = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Filtro de opciones para plan]',
              text: `${error} Descuida, puedes seguir trabajando con la tabla de resultados, nosotros vemos la manera de solucionar el inconveniente ;)`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    const getReporteAspirantes = (resolve, reject) => { // llama al servicio de reporte de Aspirantes
      // servicio 4 en wsreportes
      const jsonString = {
        columnas: selectedCheckboxColumn.value,
        status: selectedCheckbox.value,
      }
      toast({
        component: ToastificationContent,
        props: {
          title: 'Atención',
          text: 'Tu solicitud esta siendo procesada...',
          icon: 'AlertCircleIcon',
          variant: 'warning',
        },
      },
      { timeout: 10000 })
      loader.formulario = true
      emit('update:loader', loader)

      const reporteArgs = {
        plan: planFilter.value,
        inicial: fechas.value.inicio,
        final: fechas.value.fin,
        columnas: JSON.stringify(jsonString),
        periodo_id: periodoIdSelected.value,
      }

      reporteAspirantesPromise(reporteArgs).then(response => {
        resolve(response)
        loader.formulario = false
        emit('update:loader', loader)
      }, error => {
        reject(error)
        loader.formulario = false
        emit('update:loader', loader)
      })
    }

    function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
      // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData
      let CSV = ''
      let claves
      const datos = {}
      let row = ''

      // This condition will generate the Label/Header
      if (ShowLabel) {
        // This loop will extract the label from 1st index of on array
        claves = Object.keys(arrData[0])
        row = JSON.stringify(claves)
        row = row.substring(1, row.length - 1)
        // hasta aqui estan los titulos separados por comas
        CSV = `${row}\r\n`
      }
      let rows = ''
      let result = ''
      let bndAgregartitulos = true
      const valorTempClaves = claves
      // // 1st loop is to extract each row
      for (let index = 0; index < arrData.length; index += 1) {
        rows = ''
        for (let i = 0; i < valorTempClaves.length; i += 1) {
        // 2nd loop will extract each column and convert it in string comma-separated
          if (Array.isArray(arrData[index][valorTempClaves[i]])) {
            const newObjects = arrData[index][valorTempClaves[i]]
            for (let indice = 0; indice < newObjects.length; indice += 1) {
              datos[`${newObjects[indice].name}/${newObjects[indice].categoryid}`] = newObjects[indice].calificaciones
              rows += `"${newObjects[indice].calificacion}",`
            }
            if (bndAgregartitulos) {
              const valorTemporal = claves.splice(2, 1)
              claves += ','
              claves += Object.keys(datos)
              row = JSON.stringify(claves)
              result = row.substring(1, row.length - 1)
              bndAgregartitulos = false
              CSV = `${result}\r\n`
              valorTempClaves.push(valorTemporal[0])
            }
            // CSV += `${rows}\r\n`
          } else {
            // rows += `${arrData[index][valorTempClaves[i]]},`
            rows += `"${String(arrData[index][valorTempClaves[i]]).replace(/"/g, '""')}",`
          }
        }
        CSV += `${rows}\r\n`
      }
      if (CSV === '') {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'La consulta no genera ningún dato',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      } else {
      // Generate a file name
        let fileName = 'ReporteAspirantes_'
        // this will remove the blank-spaces from the title and replace it with an underscore
        fileName += ReportTitle.replace(/ /g, '_')
        // Initialize file format you want csv or xls
        const uri = `data:text/xlsx;charset=utf-8,${escape(CSV)}",`// 'data:text/csv;charset=utf-8,' + escape(CSV);
        // Now the little tricky part.
        // you can use either>> window.open(uri);
        // but this will not work in some browsers
        // or you will not get the correct file extension
        // this trick will generate a temp <a /> tag
        const link = document.createElement('a')
        link.href = uri
        // set the visibility hidden so it will not effect on your web-layout
        link.style = 'visibility:hidden'
        document.style = 'color:black'
        link.download = `${fileName}.csv` // fileName + '.csv'
        // this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }

    const descargaReporte = () => {
      informacionReporte.value = []
      // const jsonString = JSON.stringify({ ...columnasSelec.value })
      const promesa = new Promise((resolve, reject) => {
        if (selectedCheckboxColumn.value.length > 0) {
          getReporteAspirantes(resolve, reject)
        } else {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: 'Porfavor selecciona al menos una columna para descargar reporte',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 9000 })
        }
      })
      promesa
        .then(response => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: 'Información entregada con éxito',
              icon: 'AlertCircleIcon',
              variant: 'success',
            },
          },
          { timeout: 9000 })
          if (response.length === undefined) {
            informacionReporte.value.push(response)
          } else {
            informacionReporte.value = response
          }
          const currentDate = Math.floor(Date.now() / 1000)
          const diActual = timestampToDate(currentDate)
          JSONToCSVConvertor(informacionReporte.value, diActual, true)
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: 'Tenemos un detalle',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 9000 })
        })
    }
    onMounted(() => {
      loadPlan()
      // obtenerAccesoCalif()
    })
    return {
      periodos,
      periodsFromPlan,
      loadPeriodos,
      periodoFilter,
      planFilter,
      informacionReporte,
      loadPlan,
      TipoOptions,
      planOptions,
      statusOptions,
      descargaReporte,
      selectedCheckbox,
      selectedCheckboxColumn,
      selectedtipo,
      useToast,
      columnDisponibles,
      timestampToDate,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
